module.exports = __webpack_public_path__ + "static/media/aws_ccp_exam.23124328.png";